import React, { useMemo, useCallback } from 'react';
import Checkbox from '@lingxi-common-component/sirius-ui/Checkbox';
import { apiHolder, apis } from 'api';
import style from './MailMultOperation.module.scss';
import useState2RM from '../../hooks/useState2ReduxMock';
import useMailStore from '../../hooks/useMailStoreRedux';
import { LIST_MODEL, TASK_MAIL_STATUS, MAIL_LIST_CHOOSE_TYPE } from '../../common/constant';
import MailMultOperationBtns from '../MailMultOperPanel/MailMultOperationBtns';
import { MailSignCheckboxMenu } from './MailSignCheckbox';
import { getIn18Text } from 'api';
import { MailActions, useActions } from '@web-common/state/createStore';
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const MailMultOperation = props => {
    const { cancelFn } = props;
    const reducer = useActions(MailActions);
    const [listModel, setListModel] = useState2RM('defaultMailListSelectedModel', 'doUpdateMailListSelectedModel');
    const [activeIds, setActiveIds] = useState2RM('activeIds', 'doUpdateActiveIds');
    const [searchList, setSearchList] = useMailStore('searchList');
    const [mailDataList, setMailList] = useMailStore('mailDataList');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const [selectedMail, setSelectedMail] = useState2RM('selectedMailId', 'doUpdateSelectedMail');
    const checkedNum = useMemo(() => {
        if (listModel === LIST_MODEL.MULTIPLE) {
            return activeIds.length > 999 ? '999+' : `${activeIds.length}`;
        }
        return '0';
    }, [listModel, activeIds]);
    const [configMailLayout, setConfigMailLayout] = useState2RM('configMailLayout', 'doUpdateConfigMailLayout');
    const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
    const mailIdList = useMemo(() => {
        const isSearching = !!mailSearching;
        const mailList = isSearching ? searchList : mailDataList;
        return mailList.filter(mail => { var _a; return ((_a = mail === null || mail === void 0 ? void 0 : mail.taskInfo) === null || _a === void 0 ? void 0 : _a.status) !== TASK_MAIL_STATUS.PROCESSING; }).map(mail => mail.id);
    }, [mailSearching, searchList, mailDataList]);
    const indeterminate = useMemo(() => {
        return listModel === LIST_MODEL.MULTIPLE && mailIdList.length > activeIds.length;
    }, [mailIdList === null || mailIdList === void 0 ? void 0 : mailIdList.length, listModel, activeIds === null || activeIds === void 0 ? void 0 : activeIds.length]);
    const checkAll = useMemo(() => {
        return listModel === LIST_MODEL.MULTIPLE && (mailIdList === null || mailIdList === void 0 ? void 0 : mailIdList.length) <= activeIds.length;
    }, [mailIdList === null || mailIdList === void 0 ? void 0 : mailIdList.length, activeIds === null || activeIds === void 0 ? void 0 : activeIds.length, listModel]);
    const afterListMultCancel = () => {
        if (isLeftRight) {
            if (selectedMail.id) {
                setListModel(LIST_MODEL.SINGLE);
                setActiveIds([selectedMail.id]);
            }
            else {
                setListModel(LIST_MODEL.INIT);
                setActiveIds([]);
            }
        }
        else {
            setListModel(LIST_MODEL.INIT);
            setActiveIds([]);
        }
    };
    const onCheckAllChange = e => {
        if (e.target.checked) {
            reducer.chooseMailFromList({
                key: MAIL_LIST_CHOOSE_TYPE.ALL,
            });
            setTimeout(() => {
                setListModel(LIST_MODEL.MULTIPLE);
            }, 0);
        }
        else {
            afterListMultCancel();
            trackApi.track('pcMail_click_cancel_ingeneralcheckbox');
        }
    };
    const onCancel = () => {
        cancelFn && cancelFn();
        afterListMultCancel();
        trackApi.track('pcMail_click_cancel_nextgeneralcheckbox');
    };
    const domPropsRender = useCallback((mails, menuConfig) => {
        return {
            'data-test-id': 'mail-menu-list-multPanel-' + (menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.key),
        };
    }, []);
    return (React.createElement("div", { className: style.multipleOperationNew, style: {
            justifyContent: isLeftRight ? 'space-between' : 'flex-start',
            paddingLeft: !isLeftRight ? '32px' : undefined,
        } },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(Checkbox, { "data-test-id": "mail-list-tab-all-checkbox-checked", indeterminate: indeterminate, checked: checkAll, onChange: onCheckAllChange }),
            React.createElement("div", { style: { cursor: 'pointer', height: '14px', marginLeft: '6px' } },
                React.createElement(MailSignCheckboxMenu, null)),
            React.createElement("div", { style: { padding: '0 10px' }, "data-test-id": "mail-list-tab-all-checked-number" },
                getIn18Text('YIXUAN'),
                "(",
                checkedNum,
                ")")),
        React.createElement("span", { className: style.cancle, onClick: onCancel, "data-test-id": "mail-list-tab-filter-cancel-btn" }, getIn18Text('QUXIAO')),
        !isLeftRight && React.createElement(MailMultOperationBtns, { size: "mini", domProps: domPropsRender })));
};
export default MailMultOperation;
